import { render, staticRenderFns } from "./EmailStepModule.vue?vue&type=template&id=0f94b973"
import script from "./EmailStepModule.vue?vue&type=script&lang=js"
export * from "./EmailStepModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports